import Customer from "@/customer/interfaces/Customer";
import Beneficiary from "@/customer/interfaces/Beneficiary";
import ConsumerKeyService from "@/consumer/services/ConsumerKeyService";

const ConsumerService = () => {
    /**
     * Type check to determine if the consumer is a Customer.
     */
    const isCustomer = (consumer: Customer | Beneficiary): consumer is Customer => {
        return !ConsumerKeyService.isBeneficiary(consumer.consumer_key);
    };

    return {
        isCustomer
    };
};

export default ConsumerService();
